const ACTION = 'FILTER_LINKED_ADD';

const actionCreator = payload => ({ type: ACTION, payload });

actionCreator.ACTION = ACTION;

export default actionCreator;


// WEBPACK FOOTER //
// ./src/MerchantItems/ActionCreator/filterMenuLinkedItemAction.js